export default __webpack_public_path__ + "static/4-de58abfd86dfbab6e6b41e6492f51708.jpg";